import {useState} from 'react'

export function useSwitchState() {
  const [checked, setChecked] = useState(false)

  const handleTempSwitch = () => {
    setChecked((prevChecked) => !prevChecked)
  }

  return {checked, handleTempSwitch}
}
